import { Card, CardContent } from '@/components/ui/card'
import { fmtPct } from '@/lib/format-utils'

const KeyMetrics = ({ roasData }) => {
  if (!roasData || roasData.length === 0) {
    return null
  }

  // Calculate key metrics
  // 1. Breakeven day - first day ROAS >= 100%
  const breakevenDay = roasData.find((d) => d.roas >= 100)?.day || null

  // 2. Day 30 ROAS
  const day30Roas = roasData.find((d) => d.day === 30)?.roas || null

  // 3. Day 90 ROAS
  const day90Roas = roasData.find((d) => d.day === 90)?.roas || null

  // 4. Peak ROAS
  const maxRoas = Math.max(...roasData.map((d) => d.roas))
  const peakRoas = maxRoas
  const peakDay = roasData.find((d) => d.roas === peakRoas)?.day || null

  return (
    <div className="grid grid-cols-2 gap-4 md:grid-cols-4">
      {/* Breakeven Day */}
      <Card>
        <CardContent className="pt-6">
          <div className="text-sm text-slate-500">Breakeven Day</div>
          <div className="text-3xl font-bold text-blue-600">
            {breakevenDay !== null ? `Day ${breakevenDay}` : 'N/A'}
          </div>
          <div className="mt-1 text-xs text-slate-400">
            First time ROAS exceeds 100%
          </div>
        </CardContent>
      </Card>

      {/* Day 30 ROAS */}
      <Card>
        <CardContent className="pt-6">
          <div className="text-sm text-slate-500">Day 30 ROAS</div>
          <div
            className={`text-3xl font-bold ${
              day30Roas !== null && day30Roas >= 100
                ? 'text-green-600'
                : day30Roas !== null && day30Roas >= 90
                ? 'text-amber-600'
                : 'text-slate-600'
            }`}
          >
            {day30Roas !== null ? fmtPct(day30Roas) : 'N/A'}
          </div>
          <div className="mt-1 text-xs text-slate-400">
            Short-term benchmark
          </div>
        </CardContent>
      </Card>

      {/* Day 90 ROAS */}
      <Card className="border-purple-200 bg-purple-50">
        <CardContent className="pt-6">
          <div className="text-sm text-purple-600">Day 90 ROAS ★</div>
          <div
            className={`text-3xl font-bold ${
              day90Roas !== null && day90Roas >= 100
                ? 'text-green-600'
                : day90Roas !== null && day90Roas >= 90
                ? 'text-amber-600'
                : 'text-purple-700'
            }`}
          >
            {day90Roas !== null ? fmtPct(day90Roas) : 'N/A'}
          </div>
          <div className="mt-1 text-xs text-purple-500">
            Target benchmark (Our Goal)
          </div>
        </CardContent>
      </Card>

      {/* Peak ROAS */}
      <Card>
        <CardContent className="pt-6">
          <div className="text-sm text-slate-500">Peak ROAS</div>
          <div className="text-3xl font-bold text-emerald-600">
            {fmtPct(peakRoas)}
          </div>
          <div className="mt-1 text-xs text-slate-400">
            {peakDay !== null
              ? `Day ${peakDay} - Historical high`
              : 'Historical high'}
          </div>
        </CardContent>
      </Card>
    </div>
  )
}

export default KeyMetrics
